import * as React from "react"
import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils"
import { satExpandChevronRadixCn, satExpandMainRadixCn, satExpandMainRadixCompactCn, satExpandToggleRadixCn, satExpandToggleRadixCompactCn } from "@/lib/expandableSatRail"

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={cn("border-b", className)} {...props} />
))
AccordionItem.displayName = "AccordionItem"

const AccordionTrigger = React.forwardRef(({ className, children, compact = false, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "group flex flex-1 w-full min-w-0 items-stretch gap-0 py-0 text-left text-sm font-semibold text-slate-900 outline-none transition-colors hover:no-underline",
        compact ? "min-h-[2rem]" : "min-h-[2.75rem]",
        className
      )}
      {...props}
    >
      <span className={compact ? satExpandMainRadixCompactCn : satExpandMainRadixCn}>
        {children}
      </span>
      <span className={compact ? satExpandToggleRadixCompactCn : satExpandToggleRadixCn} aria-hidden>
        <ChevronDown className={satExpandChevronRadixCn} />
      </span>
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}>
    <div className={cn("pb-4 pt-0", className)}>{children}</div>
  </AccordionPrimitive.Content>
))
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
